// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1WYEY","dragIcon":"SortableItem_dragIcon__3sKKB","disabled":"SortableItem_disabled__d82Ls"};